/**
 * @generated SignedSource<<16fcd5d035dbd677a3b2845790edc365>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type actions_projectVersions_ActionsCell_jiraProject$data = {
  readonly id: string;
  readonly key: string;
  readonly " $fragmentType": "actions_projectVersions_ActionsCell_jiraProject";
};
export type actions_projectVersions_ActionsCell_jiraProject$key = {
  readonly " $data"?: actions_projectVersions_ActionsCell_jiraProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"actions_projectVersions_ActionsCell_jiraProject">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "actions_projectVersions_ActionsCell_jiraProject",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "key"
      },
      "action": "THROW",
      "path": "key"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "89a8fb84e50bfcb14d124a20a8989874";

export default node;
